var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28.4C33.9229 0 38.4 4.47715 38.4 10V28C38.4 33.5228 33.9228 38 28.4 38H9.99999C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 19.8333C19.4603 19.8333 19.8334 19.4602 19.8334 19C19.8334 18.5397 19.4603 18.1666 19.0001 18.1666C18.5398 18.1666 18.1667 18.5397 18.1667 19C18.1667 19.4602 18.5398 19.8333 19.0001 19.8333Z",
    stroke: "#6B7280",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 19.8333C25.2936 19.8333 25.6667 19.4602 25.6667 19C25.6667 18.5397 25.2936 18.1666 24.8333 18.1666C24.3731 18.1666 24 18.5397 24 19C24 19.4602 24.3731 19.8333 24.8333 19.8333Z",
    stroke: "#6B7280",
    strokeWidth: 0.833333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 19.8333C13.6268 19.8333 13.9999 19.4602 13.9999 19C13.9999 18.5397 13.6268 18.1666 13.1666 18.1666C12.7063 18.1666 12.3333 18.5397 12.3333 19C12.3333 19.4602 12.7063 19.8333 13.1666 19.8333Z",
    stroke: "#6B7280",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.8c7632c7726e789f6106eb8dc34579d7.svg";
export { ForwardRef as ReactComponent };